<template>
  <!-- 没串资料的版面 -->
  <!-- <div class="new-goods-page">
    <div class="banner">
      <img class="img-responsive" src="../Home/images/01841_03.png" alt />
    </div>
    <CaptionBar title="当季新品" subTitle="SEASON GOODS" />
    <div class="front-goods c-layout">
      <router-link
        target="_blank"
        :to="{name:'goodsDetail',query:{goods_id:item.id}}"
        class="goods-item"
        v-for="(item,index) in newList"
        :key="index"
      >
        <img class="img-responsive" :src="item.photo" alt />
        <span class="goods-item__tx1">Push up Bra</span>
        <div class="goods-item__tx2" v-if="index==0">舒適集中</div>
        <div class="goods-item__tx2" v-if="index==1">性感大方</div>
        <div class="goods-item__tx2" v-if="index==2">托高豐滿</div>
      </router-link>
    </div>

    <div class="banner-0101 c-layout">
      <div class="tx-box">
        <div class="tx1">浪漫荷葉性感鏤空內衣</div>
        <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
        <div class="tx3">MOMOOMOMOM</div>
      </div>
      <img class="img-responsive" src="./images/JET_0114.png" alt />
    </div>

    <div class="fragment c-layout">
      <div class="fragment__left">
        <img src="./images/JET_0049.png" alt />
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <button class="add-cart-btn" @click="addCart">加入購物車</button>
      </div>
      <div class="fragment__right">
        <img src="./images/JET_0352.png" alt />
        <img src="./images/JET_00sdfsd50.png" alt />
        <img src="./images/JET_0056.png" alt />
      </div>
    </div>

    <div class="orange-bg">
      <div class="banner-0101 c-layout">
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <img class="img-responsive" src="./images/JET_1883.png" alt />
      </div>

      <div class="fragment c-layout">
        <div class="fragment__left">
          <img src="./images/JET_1866.png" alt />
          <div class="tx-box">
            <div class="tx1">浪漫荷葉性感鏤空內衣</div>
            <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
            <div class="tx3">MOMOOMOMOM</div>
          </div>
          <button class="add-cart-btn" @click="addCart">加入購物車</button>
        </div>
        <div class="fragment__right">
          <img src="./images/JET_1377.png" alt />
          <img src="./images/JET_1444979.png" alt />
          <img src="./images/JET_1358.png" alt />
        </div>
      </div>
    </div>

    <div class="banner-0101 banner-0102 c-layout">
      <div class="tx-box">
        <div class="tx1">浪漫荷葉性感鏤空內衣</div>
        <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
        <div class="tx3">MOMOOMOMOM</div>
      </div>
      <img class="img-responsive" src="./images/489498418951.png" alt />
    </div>

    <div class="fragment fragment-1010 c-layout">
      <div class="fragment__left">
        <img src="./images/1843.png" alt />
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <button class="add-cart-btn" @click="addCart">加入購物車</button>
      </div>
      <div class="fragment__right">
        <img src="./images/1822.png" alt />
        <img src="./images/1848.png" alt />
        <img src="./images/1678.png" alt />
      </div>
    </div>
    <GoodsFlexible :list="recommendList" title="推薦商品" sub-title="RECOMMEND" tag="hot" />
    <GoodsFlexible :list="recentGoods"  title="最近查看" sub-title="RECENT" tag="hot" />
  </div> -->

  <!-- 串资料的版面 -->
  <div class="new-goods-page">
    <!-- <div class="banner">
      <img class="img-responsive" src="../Home/images/01841_03.png" alt />
    </div> -->
    <Banner loc="2"/>
    <CaptionBar :title="$t('new_goods.new_goods')" subTitle="SEASON GOODS" />
    <div class="front-goods c-layout">
      <!-- <router-link
        target="_blank"
        :to="{name:'goodsDetail',query:{goods_id:item.id}}"
        class="goods-item"
        v-for="(item,index) in seasonNew"
        :key="index"
      >
        <img class="img-responsive" :src="item.photo" alt />
        <span class="goods-item__tx1">Push up Bra</span>
        <div class="goods-item__tx2" v-if="index==0">舒適集中</div>
        <div class="goods-item__tx2" v-if="index==1">性感大方</div>
        <div class="goods-item__tx2" v-if="index==2">托高豐滿</div>
      </router-link> -->
      <router-link
        :to="{name:'goodsDetail',query:{goods_id:item.itemNo}}"
        class="goods-item"
        v-for="(item,index) in seasonNew"
        :key="index"
      >
        <img class="img-responsive" :src="item.cover" alt />
        <span class="goods-item__tx1">Push up Bra</span>
        <div class="goods-item__tx2">{{ item.desc }}</div>
      </router-link>
    </div>

    <div
      v-for="(item,index) in seasonNew"
      :key="index"
      :class="{ 'orange-bg': index==1  }"
    >
      <div class="banner-0101 c-layout">
        <div class="tx-box">
          <div class="tx1">{{ item.title }}</div>
          <div class="tx2">{{ item.content }}</div>
          <!-- <div class="tx3">MOMOOMOMOM</div> -->
        </div>
        <img class="img-responsive" :src="item.images[0]" alt />
      </div>

      <div class="fragment c-layout">
        <div class="fragment__left">
          <img :src="item.images[1]" alt />
          <div class="tx-box">
            <div class="tx1">{{ item.title }}</div>
            <div class="tx2">{{ item.content }}</div>
            <!-- <div class="tx3">MOMOOMOMOM</div> -->
          </div>
          <button class="add-cart-btn" @click="addCart(item.itemNo)">{{ $t('btns.add_cart') }}</button>
        </div>
        <div class="fragment__right">
          <img :src="item.images[2]" alt />
          <img :src="item.images[3]" alt />
          <img :src="item.images[4]" alt />
        </div>
      </div>
    </div>

    <!-- <div class="orange-bg">
      <div class="banner-0101 c-layout">
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <img class="img-responsive" src="./images/JET_1883.png" alt />
      </div>

      <div class="fragment c-layout">
        <div class="fragment__left">
          <img src="./images/JET_1866.png" alt />
          <div class="tx-box">
            <div class="tx1">浪漫荷葉性感鏤空內衣</div>
            <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
            <div class="tx3">MOMOOMOMOM</div>
          </div>
          <button class="add-cart-btn" @click="addCart">加入購物車</button>
        </div>
        <div class="fragment__right">
          <img src="./images/JET_1377.png" alt />
          <img src="./images/JET_1444979.png" alt />
          <img src="./images/JET_1358.png" alt />
        </div>
      </div>
    </div>

    <div class="banner-0101 banner-0102 c-layout">
      <div class="tx-box">
        <div class="tx1">浪漫荷葉性感鏤空內衣</div>
        <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
        <div class="tx3">MOMOOMOMOM</div>
      </div>
      <img class="img-responsive" src="./images/489498418951.png" alt />
    </div>

    <div class="fragment fragment-1010 c-layout">
      <div class="fragment__left">
        <img src="./images/1843.png" alt />
        <div class="tx-box">
          <div class="tx1">浪漫荷葉性感鏤空內衣</div>
          <div class="tx2">MOMOOMOMOMOMOMOMOMOMO</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <button class="add-cart-btn" @click="addCart">加入購物車</button>
      </div>
      <div class="fragment__right">
        <img src="./images/1822.png" alt />
        <img src="./images/1848.png" alt />
        <img src="./images/1678.png" alt />
      </div>
    </div> -->
    <GoodsFlexible :list="recommendList" :title="$t('goodsFlexible.recommend')" sub-title="RECOMMEND" tag="hot" />
    <GoodsFlexible :list="recentGoods"  :title="$t('goodsFlexible.recent')" sub-title="RECENT" tag="hot" />

    <AddCartDrawer ref="drawer"/>
  </div>
</template>

<script>
import CaptionBar from "@/components/CaptionBar";
import Banner from "@/components/Banner";
import GoodsFlexible from "@/components/GoodsFlexible";
import { getGoodsList,getBanner,getSeasonNew } from "@/api";
import Mixin from "@/utils/goodsMixin";
import AddCartDrawer from '@/components/AddCardDrawer/index.vue'

export default {
  mixins:[Mixin],
  data() {
    return {
      pageSize: 20,
      recommendList: "",
      newList: "",
      // bannerList: [],
      seasonNew: ''
    };
  },
  mounted() {
    // this.getPageBanner();
    this.getSeasonNew();
    this.getRecommendList();
    // this.getNewList();
  },
  methods: {
    addCart(pid) {
      this.$refs.drawer.handleOpenAddCartDrawer(pid);
    },
    async getRecommendList(data) {
      getGoodsList({ recommend: this.pageSize }).then((res) => {
        this.recommendList = res.recommend;
      });
    },
    // async getNewList(data) {
    //   getGoodsList({ new: 3 }).then((res) => {
    //     this.newList = res.new;
    //   });
    // },
    // async getPageBanner(data) {
    //   getBanner({ count:5,loc:2 }).then((res) => {
    //     this.bannerList = res.banner;
    //   });
    // },
    async getSeasonNew(data) {
      getSeasonNew({ new: 3 }).then((res) => {
        this.seasonNew = res.list;
      });
    },
  },
  components: {
    Banner,
    CaptionBar,
    GoodsFlexible,
    AddCartDrawer
  },
};
</script>

<style  lang='less'>
.new-goods-page {
  .tx-box {
    .tx1 {
      font-size: 32px;
      line-height: 32px;
      font-weight: 500;
      color: var(---unnamed-color-707070);
    }
    .tx2,
    .tx3 {
      padding-top: 15px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: var(---unnamed-color-707070);
    }
  }
  .banner {
    height: 675px;
    @media (max-width: 992px) { 
      height: auto;
    }
  }
  .caption-bar-comp {
    transform: translateY(-27px);
    .caption-line {
      width: 100%;
    }
    @media (max-width: 992px) {
      transform: translateY(-13px);
    }
  }
  .front-goods {
    display: flex;
    justify-content: space-between;
    // margin-bottom: 48px;
    @media (max-width: 992px) {
      flex-direction: column;
      padding: 10px 20px 10px 20px;
    }
    .goods-item {
      cursor: pointer;
      position: relative;
      width: 350px;
      height: 350px;
      display: block;
      @media (max-width: 992px) {
        width: 100%;
        height: 400px;
        margin-bottom: 10px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
      .goods-item__tx1 {
        top: 267px;
        left: 233px;
        position: absolute;

        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        color: var(--unnamed-color-ffffff);
      }
      .goods-item__tx2 {
        position: absolute;
        bottom: 0;
        z-index: 2;
        width: 100%;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: var(--unnamed-color-111111);
        letter-spacing: 12px;
        font-size: 24px;
        line-height: 50px;
        font-weight: 500;
        color: var(--unnamed-color-ffffff);
      }
    }
  }
  .banner-0101 {
    padding-top: 48px;
    position: relative;
    height: 1685px;
    @media (max-width: 992px) {
      padding-top: 0px;
      height: auto;
    }
    .tx-box {
      position: absolute;
      // top: 379px;
      // left: 656px;
      top: 23%;
      right: 12%;
      @media (max-width: 992px) {
        width: 100%;
        top: unset;
        bottom: 5%;
        right: 0;
        text-align: center;
      }
    }
  }
  .fragment {
    display: flex;
    justify-content: space-between;
    margin-top: 48px;

    padding-bottom: 25px;
    @media (max-width: 992px) {
      flex-direction: column-reverse;
      padding-bottom: 10px;
      margin-top: 10px;
    }
    .tx-box {
      .tx1 {
        margin-top: 10px;
      }
    }
    .fragment__right {
      width: 540px;
      @media (max-width: 992px) {
        width: 100%;
        padding: 0 20px;
      }
      img {
        display: block;
        width: 540px;
        height: 310px;
        margin-bottom: 16px;
        @media (max-width: 992px) {
          width: 100%;
          height: auto;
          margin-bottom: 10px;
        }
      }
    }
    .fragment__left {
      width: 540px;
      @media (max-width: 992px) {
        width: 100%;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      img {
        width: 100%;
        height: 700;
        object-fit: cover;
      }
      .add-cart-btn {
        margin-top: 99px;
        cursor: pointer;
        width: 125px;
        height: 40px;
        border: 1px solid var(--unnamed-color-111111);

        font-size: 13px;
        line-height: 20px;
        color: var(--unnamed-color-111111);
        @media (max-width: 992px) {
          margin-top: 40px;
          margin-bottom: 10px;
          height: auto;
          line-height: 2.5rem;
          width: 146px;
        }
      }
    }
  }
  .orange-bg {
    background: #ffc8ac;
    .tx-box {
      .tx1 {
        color: var(--unnamed-color-000000);
      }
      .tx2,
      .tx3 {
        color: var(--unnamed-color-000000);
      }
    }
    .banner-0101 {
      @media (max-width: 992px) {
        padding-top: 0;
      }
      .tx-box {
        position: absolute;
        top: 473px;
        left: 76px;
        @media (max-width: 992px) {
          width: 100%;
          top: unset;
          left: unset;
          bottom: 5%;
          right: 0;
          text-align: center;
        }
        .tx1 {
          color: var(--unnamed-color-ffffff);
        }
        .tx2,
        .tx3 {
          color: var(--unnamed-color-ffffff);
        }
      }
    }
  }
  .banner-0102 {
    .tx-box {
      .tx1 {
        color: var(--unnamed-color-ffffff);
      }
      .tx2,
      .tx3 {
        color: var(--unnamed-color-ffffff);
      }
    }
  }
  .fragment-1010 {
    padding-bottom: 55px;
    .tx-box {
      .tx1 {
        color: var(--unnamed-color-000000);
      }
      .tx2,
      .tx3 {
        color: var(--unnamed-color-000000);
      }
    }
  }
  @media (max-width: 992px) {
    .fragment__left {
      .tx-box {
        text-align: center;
        .tx1 {
          color: var(--unnamed-color-000000);
          font-size: 1.5rem;
          line-height: 2rem;
          margin-top: 26px;
        }
        .tx2,
        .tx3 {
          // color: var(--unnamed-color-000000);
          line-height: 1rem;
          font-size: 1rem;
          width: 80%;
        }
      }
      .add-cart-btn {
        
      }
    }
  }
}
</style>
